import React from 'react';
import { UserContext } from "../contexts/UserContext";
import { userService } from "../services/UserService";
import UserContextProvider from "../contexts/UserContext";

import { useParams } from 'react-router-dom';

const Verified = () => {

    let { email } = useParams()

	const { userState, dispatch } = React.useContext(UserContext);
   
    React.useEffect(() => {

        userService.verify(dispatch,email)
	
	}, [dispatch]);

    
    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-200">
            <div className="flex flex-col items-center space-y-8 p-10">
               
               
            </div>
        </div>
    );
}

export default Verified;